"use strict";
/** state: Experimental **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var popper_js_1 = require("popper.js");
var React = require("react");
var OverlayTrigger_1 = require("../OverlayTrigger");
var CLASS_NAME = 'i-popper-section';
/**
 * PopperSection is used to provide pop-up style information which doesn't need to be visible all the time.
 * Custom-styled content can be passed for display inside the PopperSection.
 * This pop-up assumes its width based on the length of the content provided to it, unlike the other {{Popover}} component
 * which takes the width of the target (Button, Icon etc)
 */
var PopperSection = /** @class */ (function (_super) {
    __extends(PopperSection, _super);
    function PopperSection(props) {
        var _this = _super.call(this, props) || this;
        _this.myRef = React.createRef();
        _this.cleanup = function () {
            if (_this.popper) {
                _this.popper.destroy();
                _this.popper = null;
            }
        };
        _this.hidePopperSection = function () {
            _this.setState({
                active: false,
            });
        };
        _this.showPopperSection = function () {
            _this.setState({
                active: true,
            });
        };
        _this.toggleVisibility = function () {
            _this.setState(function (prevState) { return ({
                active: !prevState.active,
            }); });
        };
        _this.state = {
            active: false,
        };
        _this.addedEventListeners = [];
        return _this;
    }
    PopperSection.prototype.componentDidMount = function () {
        var _this = this;
        this.props.trigger.forEach(function (event) {
            switch (event) {
                case 'hover':
                    _this.myRef.current.addEventListener('mouseenter', _this.showPopperSection);
                    _this.myRef.current.addEventListener('mouseleave', _this.hidePopperSection);
                    _this.addedEventListeners.push({
                        handler: _this.showPopperSection,
                        name: 'mouseenter',
                    }, {
                        handler: _this.hidePopperSection,
                        name: 'mouseleave',
                    });
                    break;
                case 'focus':
                    _this.myRef.current.addEventListener('focus', _this.showPopperSection);
                    _this.myRef.current.addEventListener('blur', _this.hidePopperSection);
                    _this.addedEventListeners.push({
                        handler: _this.showPopperSection,
                        name: 'focus',
                    }, {
                        handler: _this.hidePopperSection,
                        name: 'blur',
                    });
                    break;
                case 'click':
                    _this.myRef.current.addEventListener('click', _this.toggleVisibility);
                    _this.addedEventListeners.push({
                        handler: _this.toggleVisibility,
                        name: 'click',
                    });
                    break;
            }
        });
    };
    PopperSection.prototype.componentDidUpdate = function () {
        if (this.popover != null) {
            if (this.popper) {
                this.popper.destroy();
            }
            this.popper = new popper_js_1.default(this.myRef.current, this.popover, {
                placement: this.props.placement,
            });
        }
    };
    PopperSection.prototype.componentWillUnmount = function () {
        var _this = this;
        this.addedEventListeners.forEach(function (event) {
            return _this.myRef.current.removeEventListener(event.name, event.handler);
        });
        this.cleanup();
    };
    PopperSection.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "i-popper-section-target", ref: this.myRef }, this.props.children),
            this.state.active && (React.createElement("div", { className: classNames(CLASS_NAME, 'popover', {
                    'bs-popover-auto': this.state.active,
                }), ref: function (ref) {
                    _this.popover = ref;
                } },
                this.state.active && (React.createElement("div", { className: "arrow", "x-arrow": "" })),
                this.props.header && (React.createElement("div", { className: "popover-header" }, this.props.header)),
                this.props.body && (React.createElement("div", { className: "popover-body" }, this.props.body))))));
    };
    PopperSection.Placement = OverlayTrigger_1.OverlayPlacement;
    PopperSection.Trigger = OverlayTrigger_1.Trigger;
    return PopperSection;
}(React.Component));
exports.PopperSection = PopperSection;
//# sourceMappingURL=PopperSection.js.map